@if (
  {
    link: link$ | async,
    isLoading: isUpdating$ | async,
  };
  as state
) {
  <orders-order-details
    [business]="business"
    [contractStartDate]="contractStartDate"
    [contractDuration]="contractDuration"
    [config]="{
      showBusinessName: !!state.link,
      minContractStartDate: minDate,
      showContractDurationTooltip: true,
    }"
    [isLoading]="state.isLoading"
    [viewOnly]="viewOnly"
    [companyLink]="state.link"
    (contractStartDateChanged)="handleContractStartDateChange($event)"
    (contractDurationChanged)="handleContractDurationChange($event)"
  />
}
